import {action, computed, makeObservable, observable} from "mobx";
import SaporeForm from "../SaporeForm";

export default class ArticlesFormSet extends SaporeForm {
    constructor(forms, feature, isOptional = false) {
        super(isOptional)
        this._forms = forms;
        this._feature = feature;
        this._lastId = 0
        this._formsPerId = {}
        this._forms.forEach((form) => this._updateFormsPerId(form))

        makeObservable(this, {
            _forms: observable,
            forms: computed,
            _formsPerId: observable,
            formsPerId: computed,
            _updateFormsPerId: action,
        });
    }

    get formsPerId() {
        return this._formsPerId
    }

    articleOf(id) {
        return this._formsPerId[id].article()
    }

    get isValid() {
        if (this._isOptional && this._value.length === 0) {
            return true;
        }
        return this._forms.length > 0 && this._forms.every((form) => form.hasAllValidValues())
    }

    updateValue(fieldName, value, id) {
        const form = this._formsPerId[id]
        form.getFieldByName(fieldName).updateValue(value)
        this._addArticleToOrder(form);
    }

    _addArticleToOrder(form) {
        if (form.hasAllValidValues()) {
            this._feature.addArticleToOrder(form.article())
        }
    }

    addForm(form) {
        this._forms.push(form)
        this._updateFormsPerId(form)
        // this.updateValue(form.value)
    }

    deleteForm(id) {
        const form = this._formsPerId[id]
        this._forms.remove(form)
        this._feature.deleteOrdersArticle(form.article())
    }

    _updateFormsPerId(form) {
        this._formsPerId[this._lastId] = form
        this._lastId += 1
    }

    get values() {
        const completedArticles = this._forms.filter((form) => form.hasAllValidValues());
        return completedArticles.map((form) => form.values);
    }

    get forms() {
        return this._forms
    }

    set forms(newForm) {
        return this._forms = newForm
    }
}
